import { useParams } from "react-router";

export function useSeasonsListParams() {
  const { customerId, organizationId, sport } = useParams();

  if (!customerId || !organizationId || !sport) {
    throw new Error("Missing required route parameter: customerId");
  }

  return {
    customerId: Number(customerId),
    organizationId,
    sport,
  };
}
